import { Navbar, Nav, Container, NavDropdown, Button } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useProfile } from '../contexts/ProfileContext'
import { useToast } from '../contexts/ToastContext'
import PINPrompt from './PINPrompt'

function Navigation() {
  const { user, logout } = useAuth()
  const {
    activeProfile,
    profiles,
    switchProfile,
    pinPromptOpen,
    pinVerifying,
    pinError,
    verifyPinAndSwitch,
    closePinPrompt,
    requiresPinToSwitch
  } = useProfile()
  const { showSuccess } = useToast()
  const navigate = useNavigate()

  // Find parent profile for current child profile
  const parentProfile = activeProfile?.parent_profile_id
    ? profiles.find(p => p.id === activeProfile.parent_profile_id)
    : null

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  const handleSwitchToParent = () => {
    if (parentProfile) {
      switchProfile(parentProfile)
    }
  }

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">
          Bagel
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {user && (
              <>
                <Nav.Link as={Link} to="/search">Search</Nav.Link>
                <NavDropdown title="Curate" id="curate-dropdown">
                  <NavDropdown.Item as={Link} to="/curate">Add Score</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/import-bookmarks">Import Bookmarks</NavDropdown.Item>
                </NavDropdown>
                <Nav.Link as={Link} to="/networks">Networks</Nav.Link>
                <Nav.Link as={Link} to="/invite">Invite</Nav.Link>
                <NavDropdown title="Trust" id="trust-dropdown">
                  <NavDropdown.Item as={Link} to="/trust">Manage Trust</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/copy-trust">Copy Trust</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/trust-lists">Trust Lists</NavDropdown.Item>
                </NavDropdown>
                {user.is_admin && (
                  <NavDropdown title="Admin" id="admin-dropdown">
                    <NavDropdown.Item as={Link} to="/admin/reports">Reports</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/admin/hidden-content">Hidden Content</NavDropdown.Item>
                  </NavDropdown>
                )}
              </>
            )}
          </Nav>
          <Nav>
            {user ? (
              <>
                {activeProfile && profiles.length > 0 && (
                  activeProfile.parent_profile_id ? (
                    // Subordinate profile - show name and switch to parent button
                    <>
                      <Nav.Link disabled className="text-light">
                        {activeProfile.name}
                      </Nav.Link>
                      {parentProfile && (
                        <Button
                          variant="outline-light"
                          size="sm"
                          className="ms-2"
                          onClick={handleSwitchToParent}
                        >
                          Switch to {parentProfile.name}
                        </Button>
                      )}
                    </>
                  ) : (
                    // Main account - show dropdown with arrow
                    <NavDropdown title={activeProfile.name} id="profile-dropdown">
                      {profiles.map(profile => (
                        <NavDropdown.Item
                          key={profile.id}
                          onClick={() => switchProfile(profile)}
                          active={profile.id === activeProfile.id}
                        >
                          {profile.name}
                          {requiresPinToSwitch(profile) && ' (PIN)'}
                        </NavDropdown.Item>
                      ))}
                      <NavDropdown.Divider />
                      <NavDropdown.Item as={Link} to="/profiles">
                        Manage Profiles
                      </NavDropdown.Item>
                    </NavDropdown>
                  )
                )}
                <Nav.Link as={Link} to="/settings">Settings</Nav.Link>
                <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login">Login</Nav.Link>
                <Nav.Link as={Link} to="/register">Register</Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>

      <PINPrompt
        show={pinPromptOpen}
        onHide={closePinPrompt}
        onVerify={verifyPinAndSwitch}
        title="Switch to Parent"
        loading={pinVerifying}
        error={pinError}
      />
    </Navbar>
  )
}

export default Navigation
